function initials(name: string) {
	return name
		.split(/\s+/)
		.filter(Boolean)
		.slice(0, 2)
		.map((part) => part[0])
		.join("")
		.toUpperCase();
}

interface AvatarInitialsProps {
	name: string;
}

function AvatarInitials(prop: AvatarInitialsProps) {
	const { name } = prop;
	return (
		<span
			className="grid h-12 w-12 shrink-0 place-items-center rounded-full text-sm font-bold"
			style={{
				background:
					"linear-gradient(135deg, color-mix(in srgb, var(--brand-1) 28%, transparent), color-mix(in srgb, var(--brand-2) 24%, transparent))",
				color: "var(--brand-2)",
			}}
		>
			{initials(name)}
		</span>
	);
}

export default AvatarInitials;
